import { AbstractControl, ValidationErrors } from '@angular/forms';

export function strong() {
  return (control: AbstractControl): ValidationErrors | null => {
    const password = control.get('password');
    if (!password) {
      return null;
    }

    const { value } = password;

    if (value === undefined || value === null || value === '') {
      return null;
    }

    const hasUpperCase = /[A-Z]/.test(value);
    const hasLowerCase = value && /[a-z]/.test(value);
    const hasNumeric = /\d/.test(value);
    const hasSpecial = /[!@#$%^&*(),.?":{}|<>]/.test(value);
    const validLength = value?.length >= 8;

    const errors: any = {};

    const typesCount = [hasUpperCase, hasLowerCase, hasNumeric, hasSpecial].filter(Boolean).length;

    if (!hasUpperCase) {
      errors.uppercase = true;
    }
    if (!hasLowerCase) {
      errors.lowercase = true;
    }
    if (!hasNumeric) {
      errors.numeric = true;
    }
    if (!hasSpecial) {
      errors.specialChar = true;
    }

    if (!validLength) {
      errors.length = true;
    }

    if (typesCount < 3 || errors.length) {
      password.setErrors(errors);
    } else {
      password.setErrors(null);
    }

    return null;
  };
}
